import React from 'react';
import {defaultDirection} from '../constants/defaultValues';
import {toString, isObject, isEqual, transform, forEach, replace, isNaN, find} from 'lodash';
import {application} from '../constants/configs';
import ArrowRight from '@material-ui/icons/ChevronRight';
import ArrowLeft from '@material-ui/icons/ChevronLeft';
import momentJalaali from 'moment-jalaali';
import fa_IR from "../constants/locales";
import {store} from "../AppRenderer";
import i18n from '../services/i18n';
import moment from 'moment';

export const dataURItoBlob = dataURI => {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  if (dataURI.indexOf(application.apiUrl) !== -1 || !dataURI) return dataURI;
  const byteString = atob(dataURI.split(',')[1]);
  // separate out the mime component
  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0];
  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const dw = new DataView(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    dw.setUint8(i, byteString.charCodeAt(i));
  }
  // write the ArrayBuffer to a blob, and you're done
  return new Blob([ab], { type: mimeString, size: byteString.length });
};

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key], B = b[key];
    if (order.indexOf(A + '') > order.indexOf(B + '')) {
      return 1;
    } else {
      return -1;
    }
  });
  return array;
};

export const stringToNumber = content => {
  let value = content.replace(/,/g, '');
  const farsiDigits = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
  if (value && value.length) {
    for (let i = 0; i < 10; i++) {
      value = value.replace(farsiDigits[i], i);
    }
  }
  return value;
};

export const numberWithCommas = value => {
  const parts = toString(scientificToDecimal(value)).split('.');
  return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts.length > 1 ? '.' + parts[1] : '');
};

export const isJson = string => {
  try {
    const parsed = JSON.parse(string);
    return typeof parsed === 'object';
  } catch (e) {
    return false;
  }
};

export const scientificToDecimal  = value => {
  let number = String(value);
  let numberHasSign = number.startsWith('-') || number.startsWith('+');
  let sign = numberHasSign ? number[0] : '';
  number = numberHasSign ? number.replace(sign, '') : number;
  //if the number is in scientific notation remove it
  if (/\d+\.?\d*e[\+\-]*\d+/i.test(number)) {
    let zero = '0';
    let parts = number.toLowerCase().split('e'); //split into coeff and exponent
    let e = parts.pop();//store the exponential part
    let l = Math.abs(e); //get the number of zeros
    let sign = e / l;
    let coeff_array = parts[0].split('.');
    if (sign === -1) {
      coeff_array[0] = Math.abs(coeff_array[0]);
      number = zero + '.' + new Array(l).join(zero) + coeff_array.join('');
    } else {
      let dec = coeff_array[1];
      if (dec) l = l - dec.length;
      number = coeff_array.join('') + new Array(l + 1).join(zero);
    }
  }
  return `${sign}${number}`;
};

export const fixedToWithoutRound = (value, precision) => {
  if ((value || value === 0) && !isNaN(value)) {
    if (typeof precision !== 'undefined') {
      const number = scientificToDecimal(value);
      const regex = new RegExp(`^-?\\d+(?:.\\d{0,${precision}})?`);
      let result = number.match(regex)[0];
      if (precision === 0 && result[result.length - 1] === '.') {
        if (Number(result) < 0) {
          return `${numberWithCommas(result.slice(1, result.length - 1))}-`;
        }
        return numberWithCommas(result.slice(0, result.length - 1));
      } else {
        if (Number(result) < 0) {
          return `${numberWithCommas(result.slice(1, result.length))}-`;
        }
        return numberWithCommas(result);
      }
    } else {
      return numberWithCommas(value);
    }
  }
  return null;
};

export const i18nizeDate = date => {
  if (date === null || date === undefined || date === '') return '';
  if (i18n.language === fa_IR) {
    return momentJalaali(date).format('HH:mm jYYYY/jMM/jDD');
  }
  return moment(date).format('YYYY/MM/DD HH:mm');
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return dd + '.' + mm + '.' + yyyy;
};

export const getCurrentTime = () => {
  const now = new Date();
  return now.getHours() + ':' + now.getMinutes();
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem('direction')) {
    const localValue = localStorage.getItem('direction');
    if (localValue === 'rtl' || localValue === 'ltr') {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === 'rtl'
  };
};

export const setDirection = localValue => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  localStorage.setItem('direction', direction);
};

export const mapToCssModules = (className = '', cssModule) => {
  if (!cssModule) return className;
  return className
    .split(' ')
    .map(c => cssModule[c] || c)
    .join(' ');
};

export const difference = (object, base) => {
  return transform(object, function(result, value, key) {
    if (!isEqual(value, base[key])) {
      result[key] =
        isObject(value) && isObject(base[key])
          ? difference(value, base[key])
          : value;
    }
  });
};

export const getDatePickerProps = () => ({
  maxDate: moment(),
  okLabel: i18n.t('Ok'),
  cancelLabel: i18n.t('Cancel'),
  clearLabel: i18n.t('Clear'),
  ampm: false,
  disableToolbar: true,
  clearable: true,
  openTo: 'year',
  leftArrowIcon: i18n.language === 'fa-IR' ? <ArrowRight /> : <ArrowLeft />,
  rightArrowIcon: i18n.language === 'fa-IR' ? <ArrowLeft /> : <ArrowRight />,
  labelFunc: date => (date ? i18n.language === 'fa' ? date.format('HH:mm jYYYY/jMM/jDD') : date.format('YYYY/MM/DD HH:mm') : ''),
});

export const selectStyles = {
  control: provided => ({
    ...provided,
    minHeight: '40px',
    height: '40px',
  }),
  valueContainer: provided => ({
    ...provided,
    height: '40px',
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: '40px'
  }),
  clearIndicator: provided => ({
    ...provided,
    padding: '5px'
  }),
  dropdownIndicator: provided => ({
    ...provided,
    padding: '5px'
  })
};

export const mask = (value, pattern) => {
  let result = pattern;
  forEach([...value], v => {
    result = replace(result, /#/, v);
  });
  return result;
};

export const mapStatus = status => {
  switch (status) {
    case 'CONFIRMED':
      return i18n.t('Confirmed');
    case 'ACCEPTED':
      return i18n.t('Accepted');
    case 'VERIFIED':
      return i18n.t('Verified');
    case 'REJECTED':
      return i18n.t('Rejected');
    case 'PENDING':
      return i18n.t('Pending');
    case 'REPLIED':
      return i18n.t('Replied');
    case 'CLOSED':
      return i18n.t('Closed');
    case 'CANCELLED':
      return i18n.t('Cancelled');
    case 'CANCELED':
      return i18n.t('Cancelled');
    case 'WAITING':
      return i18n.t('Waiting');
    case 'REPLY_WAITING':
      return i18n.t('Waiting for answer');
    case 'REPLIED_OR_CLOSED':
      return i18n.t('Replied or closed');
    case 'BLOCKCHAIN_REJECTION':
      return i18n.t('BlockchainRejection');
    case 'FILLED':
      return i18n.t('Filled');
    case 'ACTIVATED':
      return i18n.t('Activated');
    case 'READY':
      return i18n.t('Ready');
    case 'STARTED':
      return i18n.t('Pending');
    case 'FINISHED':
      return i18n.t('Finished');
    case 'EXPIRED':
      return i18n.t('Expired');
    case 'SUBMITTED':
      return i18n.t('Submitted');
    case 'NOT_SUBMITTED':
      return i18n.t('Not Submitted');
    case 'DONE':
      return i18n.t('Done');
    case 'FAILED':
      return i18n.t('Failed');
    case 'AUTH_ERROR':
      return i18n.t('Auth Error');
    case 'AUTHENTICATED':
      return i18n.t('Done');
    case 'NOT_AUTHENTICATED':
      return i18n.t('Not Done');
    default:
      return status;
  }
};

export const mapTicketDepartment = department => {
  switch (department) {
    case 'CUSTOMER_SUPPORT':
      return i18n.t('Customer Support');
    case 'TECHNICAL':
      return i18n.t('Technical');
    case 'MANAGEMENT':
      return i18n.t('Management');
    default:
      return department;
  }
};

export const mapTnxType = type => {
  if (type === 'BLOCKCHAIN') {
    return i18n.t('Blockchain');
  } else {
    return i18n.t('Bank Payment');
  }
};

export const getSideColor = side => {
  if (side === 'BUY') {
    return 'text-success';
  } else {
    return 'text-danger';
  }
};

export const getStatusColor = status => {
  switch (status) {
    case 'Registered':
    case 'Submitted':
    case 'ACCEPTED':
    case 'AUTHENTICATED':
      return 'text-primary';
    case 'ON':
    case 'Verified':
    case 'VERIFIED':
    case 'CONFIRMED':
    case 'FILLED':
    case 'REPLIED':
    case 'FINISHED':
    case 'DONE':
      return 'text-success';
    case 'Waiting for Modification':
    case 'PENDING':
    case 'Pending':
    case 'WAITING':
    case 'STARTED':
    case 'PROCESSING':
      return 'text-warning';
    case 'OFF':
    case 'Deleted':
    case 'Rejected':
    case 'REJECTED':
    case 'AUTH_ERROR':
    case 'FAILED':
    case 'EXPIRED':
    case 'LOW_BALANCE':
    case 'LOW_BALANCE_FOR_FEE':
    case 'BLOCKCHAIN_REJECTION':
      return 'text-danger';
    case 'CANCELLED':
    case 'CANCELED':
    case 'CLOSED':
    case 'SOURCE_CANCEL':
    case 'Not Submitted':
    case 'NOT_SUBMITTED':
    case 'NOT_AUTHENTICATED':
      return 'text-black';
    default:
      return 'text-primary';
  }
};

export const getTypeColor = type => {
  switch (type) {
    case 'deposit':
      return 'text-success';
    case 'withdraw':
      return 'text-danger';
    default:
      return 'text-black';
  }
};

export const getPaymentStatus = status => {
  switch (status) {
    case 100:
    case 101:
    case 1:
      return i18n.t('Verified');
    case 99:
    case -1000:
      return i18n.t('Not Verified');
    case -100:
      return i18n.t('Blocked');
    case -101:
      return i18n.t('Block Rejected');
    default:
      return i18n.t('Rejected');
  }
};

export const getZibalResultMessage = result => {
  switch (result) {
    case 100:
      return 'با موفقیت تایید شد';
    case 102:
      return 'merchant یافت نشد';
    case 103:
      return 'merchant غیرفعال';
    case 104:
      return 'merchant نامعتبر';
    case 201:
      return 'قبلا تایید شده';
    case 105:
      return 'amount بایستی بزرگتر از 1,000 ریال باشد';
    case 106:
      return 'callbackUrl نامعتبر می‌باشد (شروع با http و یا https)';
    case 113:
      return 'amount مبلغ تراکنش از سقف میزان تراکنش بیشتر است';
    case 202:
      return 'سفارش پرداخت نشده یا ناموفق بوده است';
    case 203:
      return 'trackId نامعتبر می‌باشد';
    default:
      return 'خطایی رخ داده است';
  }
};

export const getPaymentMessage = (gateway, success, status, message, result, errors) => {
  if (gateway === 'zarinpal') {
    switch (status) {
      case 100:
        return 'عملیات موفق';
      case 101:
        return 'تراکنش وریفای شده';
      case -1000:
        return 'تایید نشده';
      case -100:
        return 'بلوکه شده';
      case -101:
        return 'بلوکه رد شده';
      case -54:
        return 'اتوریتی نامعتبر است';
      case -53:
        return 'اتوریتی برای این مرچنت کد نیست';
      case -52:
        return 'خطای غیر منتظره با پشتیبانی تماس بگیرید';
      case -51:
        return 'پرداخت ناموفق';
      case -50:
        return 'مبلغ پرداخت شده با مقدار مبلغ در وریفای متفاوت است';
      case -40:
        return 'Invalid extra params, expire_in is not valid';
      case -35:
        return 'تعداد افراد دریافت کننده تسهیم بیش از حد مجاز است';
      case -34:
        return 'مبلغ از کل تراکنش بیشتر است';
      case -33:
        return 'درصد های وارد شده درست نیست';
      case -32:
        return 'Wages is not valid, Total wages(floating) has been overload max amount';
      case -31:
        return 'حساب بانکی تسویه را به پنل اضافه کنید مقادیر وارد شده واسه تسهیم درست نیست';
      case -30:
        return 'اجازه دسترسی به تسویه اشتراکی شناور ندارید';
      case -16:
        return 'سطح تاييد پذيرنده پايين تر از سطح نقره اي است';
      case -15:
        return 'ترمینال شما به حالت تعلیق در آمده با تیم پشتیبانی تماس بگیرید';
      case -12:
        return 'تلاش بیش از حد در یک بازه زمانی کوتاه';
      case -11:
        return 'مرچنت کد فعال نیست لطفا با تیم پشتیبانی ما تماس بگیرید';
      case -10:
        return 'ای پی و يا مرچنت كد پذيرنده صحيح نيست';
      case -9:
        return 'خطای اعتبار سنجی';
      default:
        return 'خطایی رخ داده است';
    }
  }
  if (gateway === 'vandar') {
    if (errors) {
      return errors.join(' - ');
    }
    return i18n.t('Successful transaction');
  }
  if (gateway === 'zibal') {
    if (success) {
      return i18n.t('Successful transaction');
    }
    if (typeof result === 'number' && result !== 202 && result !== 100) {
      return getZibalResultMessage(result);
    }
    switch (status) {
      case -1000:
        return 'تایید نشده';
      case -100:
        return 'بلوکه شده';
      case -101:
        return 'بلوکه رد شده';
      case -1:
        return 'در انتظار پردخت';
      case -2:
        return 'خطای داخلی';
      case 1:
        return 'پرداخت شده - تاییدشده';
      case 2:
        return 'پرداخت شده - تاییدنشده';
      case 3:
        return 'لغوشده توسط کاربر';
      case 4:
        return 'شماره کارت نامعتبر می‌باشد';
      case 5:
        return 'موجودی حساب کافی نمی‌باشد';
      case 6:
        return 'رمز واردشده اشتباه می‌باشد';
      case 7:
        return '‌تعداد درخواست‌ها بیش از حد مجاز می‌باشد';
      case 8:
        return '‌تعداد پرداخت اینترنتی روزانه بیش از حد مجاز می‌باشد';
      case 9:
        return 'مبلغ پرداخت اینترنتی روزانه بیش از حد مجاز می‌باشد';
      case 10:
        return 'صادرکننده‌ی کارت نامعتبر می‌باشد';
      case 11:
        return 'خطای سوییچ';
      case 12:
        return 'کارت قابل دسترسی نمی‌باشد';
      default:
        return 'وضعیت نامشخص';
    }
  }
  if (gateway === 'pay') {
    if (status && Number(status) !== 1 && message) {
      return message;
    }
    return i18n.t('Successful transaction');
  }
};

export const getPaymentStatusColor = status => {
  switch (status) {
    case 100:
    case 101:
    case 1:
      return 'text-success';
    case -1000:
      return 'text-warning';
    case -100:
      return 'text-danger';
    default:
      return 'text-black';
  }
};

export const mapWithdrawError = error => {
  if (error === 'WRONG_WITHDRAW_WALLET_ADDRESS_FORMAT') {
    return i18n.t('Withdraw destination wallet address is incorrect');
  }
};

export const downloadFile = url => {
  const split = url.split('/');
  const link = document.createElement('a');
  link.setAttribute('download', split[split.length - 1]);
  link.href = url;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const momentToISOFormat = momentDate => {
  const date = moment(momentDate).toDate();
  return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
};

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const getTokenDecimals = symbol => {
  const {general} = store.getState();
  const token = find(general.tokens, item => item.symbol === symbol);
  return token ? token.displayDecimal : 10;
};

export const createUUID = () => {
  const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
};